// extracted by mini-css-extract-plugin
export var leftAlign = "_18-2";
export var popper = "_18-0";
export var subtitle = "_18-1";